import api from '@shared/api';
import routes from '@root/routes';
import { PARAMETERS, EVENT_TYPES } from '@root/tracking/constants';
import { Landlord } from '@root/types';
import actions from '../index';

export type LandlordPageLoadAction = {
  type: 'LANDLORD_PAGE_LOADED';
  payload: {
    data: Landlord;
    meta: {
      analytics: {
        eventType: 'page';
        event: 'brand page';
      };
    };
  };
};

export const landlordPageLoadAction = (landlord: Landlord): LandlordPageLoadAction => ({
  type: 'LANDLORD_PAGE_LOADED',
  payload: {
    data: landlord,
    meta: {
      analytics: {
        eventType: EVENT_TYPES.page,
        event: PARAMETERS.landlordPage,
      },
    },
  },
});

export type ReceiveBuildingOwnerSavedStatusAction = {
  type: 'RECEIVE_BUILDING_OWNER_SAVE_STATUS';
  payload: { slug: string; saveStatus: boolean };
};
const receiveBuildingOwnerSaveStatus = (
  slug: string,
  saveStatus: boolean,
): ReceiveBuildingOwnerSavedStatusAction => ({
  type: 'RECEIVE_BUILDING_OWNER_SAVE_STATUS',
  payload: { slug, saveStatus },
});

const landlordPageLoad =
  ({ slug }: { slug: string }) =>
  async dispatch => {
    const data: Landlord = await api.fetch(routes.api.landlord(slug)).then(res => res.json());
    await dispatch(actions.setLandlordPage({ landlordName: data.name, slug }));
    dispatch(landlordPageLoadAction(data));

    api
      .fetch(routes.api.buildingOwnerSave(slug))
      .then(res => res.json())
      .then((saveStatus: boolean) => {
        dispatch(receiveBuildingOwnerSaveStatus(slug, saveStatus));
      });
  };

export default landlordPageLoad;

export type Actions = LandlordPageLoadAction | ReceiveBuildingOwnerSavedStatusAction;
